export default "__VITE_ASSET__c69cff37__"